export default "__VITE_ASSET__C$k0_RNe__"